export const userConstants = {
    LOGIN_REQUEST: 'USERS_LOGIN_REQUEST',
    LOGIN_SUCCESS: 'USERS_LOGIN_SUCCESS',
    LOGIN_FAILURE: 'USERS_LOGIN_FAILURE',
    
    LOGOUT: 'USERS_LOGOUT',

    GETALL_REQUEST: 'USERS_GETALL_REQUEST',
    GETALL_SUCCESS: 'USERS_GETALL_SUCCESS',
    GETALL_FAILURE: 'USERS_GETALL_FAILURE',


    CREATE_USER_REQUEST: 'CREATE_USER_REQUEST',
    CREATE_USER_SUCCESS: 'CREATE_USER_SUCCESS',
    CREATE_USER_FAILURE: 'CREATE_USER_FAILURE',

    GET_ADMIN_USER_REQUEST: 'GET_USER_REQUEST',
    GET_ADMIN_USER_SUCCESS: 'GET_ADMIN_USER_SUCCESS',
    GET_ADMIN_USER_FAILURE: 'GET_ADMIN_USER_FAILURE',

    GET_APP_USER_REQUEST: 'GET_APP_USER_REQUEST',
    GET_APP_USER_SUCCESS: 'GET_APP_USER_SUCCESS',
    GET_APP_USER_FAILURE: 'GET_APP_USER_FAILURE',

    UPDATE_USER_REQUEST: 'UPDATE_USER_REQUEST',
    UPDATE_USER_SUCCESS: 'UPDATE_USER_SUCCESS',
    UPDATE_USER_FAILURE: 'UPDATE_USER_FAILURE',

    UPDATE_APP_USER_REQUEST:'UPDATE_APP_USER_REQUEST',
    UPDATE_APP_USER_SUCCESS:'UPDATE_APP_USER_SUCCESS',
    UPDATE_APP_USER_FAILURE:'UPDATE_APP_USER_FAILURE',

    IPLOGS_REQUEST: 'IPLOGS_REQUEST',
    IPLOGS_SUCCESS: 'IPLOGS_SUCCESS',
    IPLOGS_FAILURE: 'IPLOGS_FAILURE',
};
